import { takeEvery, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';

import {
  sendForm,
  loadFormData,
  recoveryFields,
  setErrors,
  clearAllErrors,
  requestFinished,
  selectFormBody,
  selectState
} from '../../../../common/reducers/forms/profileForm';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../common/reducers/states/authAccount';

function* getUserProfile(reducerName) {
  const state = yield select(selectState, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserService.getUserById,
      state.updateObjectId
    );
    if (response.restructureData) {
      yield put(recoveryFields(reducerName, response.restructureData));
    }
    yield put(requestFinished(reducerName, response.status));
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

function* saveUserProfile(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(timeoutCall, UserService.updateMe, formBody);
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        // TODO Статика, нужно передавать с сервера
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: t('Ваш профиль успешно сохранен!')
          })
        );
        yield put(sendGetAuthAccountDataRequest());
      }
      yield put(requestFinished(reducerName, response.status));
    }
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendForm(reducerName).type, saveUserProfile, reducerName),
    takeEvery(loadFormData(reducerName).type, getUserProfile, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/profileFormSaga.js